<template>
    <v-form ref="form">
        <v-card>
            <v-card-title>
                <span class="headline">{{ $vuetify.lang.t('$vuetify.custom.exam.examUpdate') }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row class="mt-6">
                        <v-col cols="12">
                            <v-text-field
                                :rules="[rules.required]"
                                :label="$vuetify.lang.t('$vuetify.custom.exam.examName')+'*'"
                                v-model="examMsg.examName"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value.sync="examMsg.examTime"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="examMsg.examTime"
                                        label="考试时间"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="examMsg.examTime" locale="zh-cn" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="menu = false">取消</v-btn>
                                    <v-btn text color="primary" @click="$refs.menu.save(examMsg.examTime)">确定</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                                :items="typeItems"
                                :label="$vuetify.lang.t('$vuetify.custom.exam.type')"
                                hide-details
                                solo
                                v-model="examMsg.type"
                            ></v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                                :items="examTypeItems"
                                :label="$vuetify.lang.t('$vuetify.custom.exam.examType')"
                                hide-details
                                solo
                                v-model="examMsg.examType"
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" dark @click="hiddenDialog">{{ $vuetify.lang.t('$vuetify.custom.cancelBtn') }}
                </v-btn>
                <v-btn color="success" dark @click="addUser">{{ $vuetify.lang.t('$vuetify.custom.class.update') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<style></style>
<script>

    export default {
        name: 'exam-update',
        model: {
            prop: 'examDialog',
            event: 'parent-event'
        },
        props: {
            examDialog: Boolean,
            examMsg:Object
        },
        data: () => ({
            typeItems:[
                {text: '月考', value: 1},
                {text: '周考', value: 0},
            ],
            examTypeItems:[
                {text: '笔试', value: 1},
                {text: '面试', value: 0},
            ],
            menu:false,
            rules: {
                required: value => !!value || '请输入'
            },
            numRules:[
                v => !!v || '必填',
                v => /^([1-9]\d?|100)$/.test(v) || '1-100之内',
            ],
        }),
        methods: {
            hiddenDialog() {
                this.$emit('initialize')
                this.$emit('parent-event', false);
            },
            addUser() {
                if (this.$refs.form.validate()) {
                    this.$api.exam.updateExam(this.examMsg).then(data => {
                      if (data.flag) {
                        this.$dialog.alert("修改成功");
                        this.$emit('initialize')
                        this.hiddenDialog();
                      }else{
                        this.$dialog.alert(data.msg)
                      }
                    })

                }
            }
        },
        components: {
        },
    }
</script>
